export const carouselStyles = {
  container: {
    position: 'relative' as const,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: 0,
  },
  slide: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  navigationIcon: {
    position: 'absolute' as const,
    top: '50%',
    transform: 'translateY(-50%)',
    left: '10px',
    zIndex: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
    '@media (max-width: 1300px)': {
      display: 'none',
    },
  },
  navigationIcon_Mobile: {
    display: 'none',
  },
  bottomNavigator: {
    position: 'absolute' as const,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  dot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    margin: '0 5px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '2px solid transparent',
  },
  dotActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    border: '2px solid rgba(0, 0, 0, 1)',
    transform: 'scale(1.2)',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.8)',
  },
};
